/**
 * Section 컴포넌트
 * @description 화면 안 한 구간의 가로 여백을 맡는다. 스크린은 좌우를 갖지 않고, 이미지처럼
 *   가장자리까지 채워야 하는 구간은 `padding='none'` 으로 그대로 통과시킨다.
 *   앱 `shared/ui/Section` 의 웹 포팅.
 * @example
 * <Section><p>{post.content}</p></Section>
 * <Section padding='sm'><SectionHeader title="Collab Spotlights" /></Section>
 */
import { memo } from "react";

import { sectionStyles } from "./Section.styles";
import type { SectionProps } from "./Section.types";

const Section = memo<SectionProps>(({ children, padding, testID }) => (
  <div className={sectionStyles({ padding })} data-testid={testID}>
    {children}
  </div>
));

Section.displayName = "Section";

export default Section;
